import Vue from "vue";
import {closestSelector} from "../../../../commonjs/helpers";

export default {
    namespaced : true,
    state: {
        hoveredElement : null , ///node indicating which element is currently hovered
        hoveredSection : null ,// node indicating which section is currently hovered , auto updated by hoveredElement
        activeDeviceStyleFile: "",
        activeDevicePreview: "",
        availableDevicePreviews: {
            "desktop" : {
                classes: "desktop",
                thumbnail: window.imagePath + "/author/images/pagesbuilder/desktop-icon-dark.png",
                value: "desktop",
                mediaQuery: {
                    minWidth: false,
                    maxWidth: false
                },
                fontScale: 100,
                width: "100%",
                height: "100%",
                file: "commonless/pagesbuilder/pagesbuilder-responsive-laptop-desktop",
            },
            "tablet-portrait" : {
                classes: "tablet-portrait",
                thumbnail: window.imagePath + "/author/images/pagesbuilder/tablet-portrait-icon-dark.png",
                value: "tablet-portrait",
                mediaQuery: {
                    minWidth: 768,
                    maxWidth: 991
                },
                fontScale: 90,
                width: "560px",
                height: "760px",
                file: "commonless/pagesbuilder/pagesbuilder-responsive-tablet-portrait"
            },
            "tablet-landscape" : {
                classes: "tablet-landscape",
                thumbnail: window.imagePath + "/author/images/pagesbuilder/tablet-landscape-icon-dark.png",
                value: "tablet-landscape",
                mediaQuery: {
                    minWidth: 992,
                    maxWidth: 1367
                },
                fontScale: 100,
                width: "760px",
                height: "560px",
                file: "commonless/pagesbuilder/pagesbuilder-responsive-tablet-landscape"
            },
            "smartphone-portrait" : {
                classes: "smartphone-portrait",
                thumbnail: window.imagePath + "/author/images/pagesbuilder/smartphone-portrait-icon-dark.png",
                value: "smartphone-portrait",
                mediaQuery: {
                    minWidth: false,
                    maxWidth: 567
                },
                fontScale: 80,
                width: "250px",
                height: "479px",
                file: "commonless/pagesbuilder/pagesbuilder-responsive-smartphone-portrait"
            },
            "smartphone-landscape" : {
                classes: "smartphone-landscape",
                thumbnail: window.imagePath + "/author/images/pagesbuilder/smartphone-landscape-icon-dark.png",
                value: "smartphone-landscape",
                mediaQuery: {
                    minWidth: 568,
                    maxWidth: 767
                },
                fontScale: 80,
                width: "479px",
                height: "250px",
                file: "commonless/pagesbuilder/pagesbuilder-responsive-smartphone-landscape"

            },
        },
        fullscreenStatus : !window.isLoadedInIframe(),
        inPageBuilderView : false,
        selectedElement : null , //node indicating which element is currently selected
        selectedSection : null, //node indicating which section is currently selected , auto updated by selectedElement
        isScrolling: false, //tracks if user is scrolling the page
        viewportHeight: 0,
        viewportWidth: 0
    },
    getters: {
        selectedNodeState: ( state,getters,rootState) => {
            let componentStates = rootState.components.componentStates;
            let elementStates = rootState.elements.elementStates;
            let sectionStates = rootState.sections.sectionStates;
            //we keep track of everything thats selected but we need the state of a node that has been initialised by a manager
            let closestEditableNode = state.selectedElement ? state.selectedElement.closest(rootState.classSelectors.nodeWithDataTypeAttribute + " , ." + rootState.classSelectors.sectionNode) : null;
            let closestEditableNodeId = closestEditableNode ? closestEditableNode.id : "";
            let nodeState = null;


            if (!closestEditableNodeId) {
                return null;
            }

            if (componentStates[closestEditableNodeId]) {
                nodeState = componentStates[closestEditableNodeId];
            } else if (elementStates[closestEditableNodeId]) {
                nodeState = elementStates[closestEditableNodeId];
            } else if (sectionStates[closestEditableNodeId]) {
                nodeState = sectionStates[closestEditableNodeId];
            }

            return nodeState;
        },
        selectedSectionState: (state,getters,rootState) => {
            let sectionStates = rootState.sections.sectionStates;
            let selectedSectionId = state.selectedSection ? state.selectedSection.id : "";

            if (sectionStates[selectedSectionId]) {
                return sectionStates[selectedSectionId];
            }

            return null;
        },
        hoveredNodeState: (state,getters,rootState) => {
            let componentStates = rootState.components.componentStates;
            let elementStates = rootState.elements.elementStates;
            let sectionStates = rootState.sections.sectionStates;

            //we keep track of everything thats hovered but we need the state of a node that has been initialised by a manager
            let closestEditableNode = state.hoveredElement ? state.hoveredElement.closest(rootState.classSelectors.nodeWithDataTypeAttribute + " , ." + rootState.classSelectors.sectionNode) : null;
            let closestEditableNodeId = closestEditableNode ? closestEditableNode.id : "";
            let nodeState = null;

            if (componentStates[closestEditableNodeId]) {
                nodeState = componentStates[closestEditableNodeId];
            } else if (elementStates[closestEditableNodeId]) {
                nodeState = elementStates[closestEditableNodeId];
            } else if (sectionStates[closestEditableNodeId]) {
                nodeState = sectionStates[closestEditableNodeId];
            }

            return nodeState;
        },
        hoveredSectionState: (state,getters,rootState) => {
            let sectionStates = rootState.sections.sectionStates;
            let hoveredSectionId = state.hoveredSection ? state.hoveredSection.id : "";

            if (sectionStates[hoveredSectionId]) {
                return sectionStates[hoveredSectionId];
            }

            return null;
        },
        hoveredNodeSameContentWrapperState: (state,getters,rootState) => {


            let componentStates = rootState.components.componentStates;
            let elementStates = rootState.elements.elementStates;
            let sectionStates = rootState.sections.sectionStates;

            //we keep track of everything thats hovered but we need the state of a node that has been initialised by a manager
            let closestEditableNode = closestSelector(state.hoveredElement,rootState.classSelectors.sameContentWrapper);
            let closestEditableNodeId = closestEditableNode ? closestEditableNode.id : "";
            let nodeState = null;

            if (elementStates[closestEditableNodeId]) {
                nodeState = elementStates[closestEditableNodeId];
            } else if (componentStates[closestEditableNodeId]) {
                nodeState = componentStates[closestEditableNodeId];
            } else if (sectionStates[closestEditableNodeId]) {
                nodeState = sectionStates[closestEditableNodeId];
            }

            return nodeState;
        },
        hoveredNodeColumnWrapperState: (state,getters,rootState) => {
            let componentStates = rootState.components.componentStates;
            let elementStates = rootState.elements.elementStates;
            let sectionStates = rootState.sections.sectionStates;

            //we keep track of everything thats hovered but we need the state of a node that has been initialised by a manager
          let closestEditableNode = closestSelector(state.hoveredElement, '[data-node-type=column]');
          let closestEditableNodeId = closestEditableNode ? closestEditableNode.id : "";
            let nodeState = null;

            if (elementStates[closestEditableNodeId]) {
                nodeState = elementStates[closestEditableNodeId];
            } else if (componentStates[closestEditableNodeId]) {
                nodeState = componentStates[closestEditableNodeId];
            } else if (sectionStates[closestEditableNodeId]) {
                nodeState = sectionStates[closestEditableNodeId];
            }

            return nodeState;
        },
        hoveredNodeComponent: (state, getters, rootState) => {
          let componentStates = rootState.components.componentStates;
          //we keep track of everything thats hovered but we need the state of a node that has been initialised by a manager
          let closestEditableNode = closestSelector(state.hoveredElement, '.js-component');
          return closestEditableNode ? componentStates[closestEditableNode.id] : null;
        }
    },
    actions : {
        setActiveDeviceStyleFile ({commit}, payload) {
            commit('setActiveDeviceStyleFile',payload);
        },
        setActiveDevicePreview ({commit}, payload) {
            commit('setActiveDevicePreview',payload);
        },
        setFullscreenStatus ( {commit} , payload) {
            commit('setFullscreenStatus',payload);
        },
        setElementStatus ( {commit} , payload) {
            commit('setElementStatus' , payload);
        },
        setIsScrolling ( {commit},payload) {
            commit('setIsScrolling' , payload);
        },
        setPagebuilderView ( {commit},payload) {
            commit('setPagebuilderView' , payload);
        },
        setViewportDimensions ( {commit},payload) {
            commit('setViewportDimensions' , payload);
        },
    },
    mutations : {
        setActiveDeviceStyleFile ( state , fileData) {
            Vue.set(state,"activeDeviceStyleFile", fileData);
        },
        setActiveDevicePreview (state , device) {
            state.activeDevicePreview = device;
        },
        setViewportDimensions (state , dimensions) {
            state.viewportHeight = dimensions.height;
            state.viewportWidth = dimensions.width;
        },
        setPagebuilderView (state , flag) {
            state.inPageBuilderView = flag;
        },
        setFullscreenStatus (state , flag) {
            state.fullscreenStatus = flag;
        },
        setIsScrolling (state , flag) {
            state.isScrolling = flag;
        },
      setElementStatus(state, data) {
        // state.hoveredElement = data.hoveredElement;
        // state.hoveredSection = data.hoveredSection;
        // console.log(data);
            Object.keys(data).map(key => {
                state[key] = data[key];
            })
        },
    }
}
